import createActionType from "../../utils/createActionType";

export const MODULE = "pdf-customisation/select-template";

export const SET_IS_CREATING_TEMPLATE_STATUS = createActionType(
  MODULE,
  "setIsCreatingTemplateStatus"
);

export const RESET = createActionType(MODULE, "reset");
